import { useMediaQuery } from '@/hooks/useMediaQuery';
import { Stack } from '@nautilusbio/nb-design-system/Stack';
import React, { type FC, type ReactNode } from 'react';

import LoginGraphic from './LoginGraphic';
import styles from './styles.module.css';

interface LoginContainerProps {
  children: ReactNode;
}

const LoginContainer: FC<LoginContainerProps> = ({ children }) => {
  const isLargeScreen = useMediaQuery('(min-width: 769px)');

  return (
    <Stack className={styles.container} fullWidth orientation="horizontal">
      {isLargeScreen && <LoginGraphic />}
      <div className={styles.formPanel}>{children}</div>
    </Stack>
  );
};

export default LoginContainer;
